import { observable } from "mobx";
import { Type } from "class-transformer";
import TimeSpan from "./timeSpan";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class OpeningHoursIntervalResponse {
  @observable
  @Type(() => TimeSpan)
  from!: TimeSpan;

  @observable
  @Type(() => TimeSpan)
  to!: TimeSpan;
}
